import { background, extendTheme } from "@chakra-ui/react";
import components from "./components";

const theme = extendTheme({
  components,
  colors: {
    blue: {
      100: "#0062FF",
      200: "#0173BC",
      300: "#0073BB",
    },
    orange: {
      100: "#FF6700",
      200: "#EA582B",
    },
    // EG-40: red.100 guardava "#8AD657", que é VERDE. Nenhum código consome
    // esse token diretamente — quem consome é o Chakra, no fundo do
    // <Alert status="error">. Resultado: todo alerta de erro do painel
    // aparecia verde. Os botões com colorScheme="red" não eram afetados
    // porque usam red.500/600, que caem no vermelho padrão do Chakra.
    red: {
      100: "#FED7D7",
      200: "#FC8181",
    },
    green: {
      100: "#598F3C",
      200: "#78C151",
    },
    gray: {
      900: "#181B23",
      600: "#4B4D63",
      500: "#616488",
      400: "#797D9A",
      300: "#5C6066",
      200: "#F5F8F6",
      100: "#F5F5FB",
    },
  },
  fonts: {
    heading: `'Raleway', sans-serif`,
    body: `'Raleway', sans-serif`,
  },
  styles: {
    global: {
      body: {
        fontFamily: "body",
        background: "#F5F5FB",
        color: "#292B30",
      },
      input: {
        fontFamily: "body",
        fontSyze: "sm",
        lineHeight: "normal",
        background: '#F5F5FB'
      },
    },
  },
});

export default theme;
